export enum enumBondRequestResultError {
  SENDING,
  PAYMENT,
  UNKNOWN,
}
